import Axios from 'axios';

class DeliveryAddressApi {

    constructor() {
        this.api = Axios.create({
            baseURL: '/api/DeliveryAddress'
        });
        this.customerRegApi = Axios.create({
            baseURL: '/api/CustomerRegistration'
        });
    };

    createDeliveryAddress(param) {
        return this.api.post('/CreateDeliveryAddressAsync', param);
    };
 

    listDeliveryAddresses() {
        return this.api.get('/ListDeliveryAddressesAsync');
    };

    getDeliveryAddress(id) {
        return this.api.get('/GetDeliveryAddressAsync', { params: { ekstraLeveringsAdresseId: id } });
    };

    getCurrentDeliveryAddress() {
        return this.api.get('/GetCurrentDeliveryAddressAsync' );
    };

    removeDeliveryAddress(id) {
        return this.api.post('/RemoveDeliveryAddressAsync', { EkstraLeveringsAdresseId: id });
    };
    setSelectedDeliveryAddress(id) {
        return this.api.post('/SelectDeliveryAddressAsync', { EkstraLeveringsAdresseId: id });
    };

    listCountries() {
        return this.api.get('/ListCountriesAsync');
    };
    getCountry() { 
        return this.api.get('/GetCurrentCountry');
    };

    getCity(postCode, countryId) {
        return this.api.get('/GetPoststedByPostNr', {
            params: {
                postcode: postCode,
                countryId: countryId
            }
        });
    }
}

export default new DeliveryAddressApi();